<template>
  <div class="loginBox">
    <div class="safe_area">
      <div class="logo">
        <!-- <img src="@/assets/images/login/title_picture.png" alt=""> -->
        <img :src="$store.getters.sysLogo" style="width: 100px; height: 100px;" alt="">
        <img :src="$store.getters.sysTitleImage" alt="">
      </div>
      <div class="position-all-wrapper">
        <!-- <div class="empty-box"></div> -->
        <!-- <a v-if="isShowDownloadEntrance" href="http://qxja.thecfa.cn" target="_blank"><p class="cfa_center">中国足协精英青训教练员培训教案编写>></p></a> -->
        <div class="login-flex-wrapper">
          <div v-show="!forget" class="login_wrap">
            <div class="login-title"></div>
            <div class="input_box">
              <!-- placement：位置  effect 主题 -->
              <!--<el-tooltip content="提示：用户名为证件号" placement="bottom-end" effect="light">-->
              <!--<img class="name_tip" src="@/assets/images/login/warn-message.png" alt="">-->
              <!--</el-tooltip>-->
              <input
                v-model.trim="userName"
                class="username"
                type="text"
                :class="nameWraing ? 'error': ''"
                autocomplete="off"
                placeholder="请输入用户名"
                @focus="nameWraing = false">
              <div class="icon_box">
                <v-icon name="user" scale="1"></v-icon>
              </div>
            </div>
            <div class="input_box">
              <input
                v-model.trim="passWord"
                type="password"
                autocomplete="off"
                placeholder="请输入密码"
                :class="pwdWraing ? 'error': ''"
                @keyup.enter="check"
                @focus="pwdWraing = false">
              <div class="icon_box">
                <v-icon name="lock" scale="1"></v-icon>
              </div>
            </div>
            <div class="btn" @click="check">登录</div>
            <div class="btn mt10 primary" v-if="$store.getters.sysRegister" @click="toRegionPage">注册</div>
            <div class="other_info">
              <div class="remember_pwd">
                <input v-model="rememberUser" type="checkbox">
                <label></label>
                记住帐号密码
              </div>
              <div class="forget_pwd" @click="forgetPwd">忘记密码？</div>
            </div>
            <div class="tip">
              <a v-if="isWin" target="_blank" href="https://browser.360.cn/ee/">请使用计算机下载360极速浏览器登录本系统</a>
              <a v-else-if="isMac" target="_blank" href="https://browser.360.cn/ee/mac">请使用计算机下载360极速浏览器登录本系统</a>
              <a v-else target="_blank" href="https://browser.qq.com/">请下载QQ浏览器登录本系统</a>
            </div>
          </div>
          <div class="in-box" v-if="isInClubSystem && !forget">
            <div class="buttonSuggestTips">
              <a href="http://sfaclub.yioks.cn/uploads/templateFile/申报手册--2026—2029年上海市青少年足球精英培训机构申报认定工作平台精英机构管理员操作手册V2.0.pdf" target="_blank" download="申报手册--2026—2029年上海市青少年足球精英培训机构申报认定工作平台精英机构管理员操作手册V2.0.pdf"><p class="t-tips">《使用指导手册（精英机构/基地）》下载 </p></a>
            </div>

          </div>
          <div class="in-box1" v-if="!isInClubSystem && !forget">
            <div class="buttonSuggestTips">
              <a href="http://sfa.yioks.cn/uploads/templateFile/精英基地--上海市青少年足球精英培训基地综合服务管理平台基地管理员说明手册V1.0.pdf" target="_blank" download="精英基地--上海市青少年足球精英培训基地综合服务管理平台基地管理员说明手册V1.0.pdf" style="margin-right:5px"><p class="t-tips">《使用指导手册（精英机构）》下载 </p></a>
              <a href="http://sfa.yioks.cn/uploads/templateFile/精英基地--上海市青少年足球精英培训基地综合服务管理平台教练员说明手册V1.0.pdf" target="_blank" download="精英基地--上海市青少年足球精英培训基地综合服务管理平台教练员说明手册V1.0.pdf" style="margin-right:5px"><p class="t-tips">《使用指导手册（教练员）》下载 </p></a>
              <p class="t-tips" @click="isQuestion = true"> 教练员操作视频 </p>
            </div>

          </div>
        </div>
      </div>
      <forget-pwd :forget.sync="forget" />
    </div>
    <PageFoot />
    <el-dialog
      title="验证手机号及重置密码"
      custom-class="VerifyPhone"
      :visible.sync="isVerifyPhone"
      :close-on-click-modal="false"
      :show-close="false"
      width="450px">
      <div id="VerifyPhone">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="100px">
          <el-form-item label="手机号">
            <el-row style="position: relative">
              <el-col :span="14">
                <el-input v-model="form.mobile_phone" disabled></el-input>
              </el-col>
              <el-col :span="10" style="text-align:right">
                <el-row type="flex" justify="end">
                  <el-button v-if="codeBtnFlag" type="primary" @click="sendCode">发送验证码
                  </el-button>
                  <el-button v-else disabled type="info">{{sec}}秒后重发
                  </el-button>
                </el-row>
              </el-col>
              <el-tooltip  placement="right" effect="light">
                <div slot="content" class="no_code_method">
                  <p>解决办法</p>
                  <p>1: 通讯异常会造成短信发送延时或者丢失，请尝试重新获取短信验证码；</p>
                  <p>2: 查看垃圾短信，是否被短信过滤软件拦截；</p>
                  <p>3: 请确认手机号码是否正确，手机是否欠费；</p>
                  <p>4: 关机后重新启动手机，重新加载手机和基站的通信链路；</p>
                  <p>5: 联系电话客服；</p>
                </div>
                <div class="get_none_code"  >收不到验证码？</div>
              </el-tooltip>
            </el-row>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model.trim="form.code" placeholder="请输入验证码"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pwd">
            <el-input v-model.trim="form.pwd" type="password" placeholder="请输入8—16位字母和数字组合"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="affirm_pwd">
            <el-input v-model.trim="form.affirm_pwd" type="password" placeholder="请确认新密码"></el-input>
          </el-form-item>
          <div v-show="errPhoneFlag" class="tips">{{ errPhoneMsg }}
          </div>
          <div class="btns">
            <div class="btn yes" @click="onSubmitPwd">确定 </div>
            <div class="btn no" @click="isVerifyPhone = false ; repeatSubmit = false">取消
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!--  信息收集表弹窗  -->
    <dialog-wrapper
      :title="'请选择协会填写'"
      :showFlag="isShowColect"
      :isShowCancel="false"
      :successBtn="'填写'"
      :canClickClose="false"
      :confirmLoading="isDialogConfirm"
      @hideDialog="handleColectDialogConfirm"
      @handleCloseBefor="beforeCloseFunc"
    >
      <div class="dialog-wrapper colect-info" >
        <el-form ref="colectForm" :model="colectFormData" :rules="colectrules" label-width="80px">

          <el-form-item prop="organName" label="协会名称">
            <el-select class="w340px" v-model="colectFormData.organName" filterable clearable="" placeholder="请选择区体育行政部门">
              <el-option
                v-for="item in orgList"
                :key="item.uuid"
                :label="item.organName"
                :value="item.organName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="password" label="校验码">
            <el-input class="w340px" v-model.trim="colectFormData.password" placeholder="请输入校验码"></el-input>
          </el-form-item>
        </el-form>
        <!-- 协会  校验码 -->
      </div>
    </dialog-wrapper>

    <!-- 教练员推荐 -->
    <dialog-wrapper
      :title="'请选择推荐协会'"
      :showFlag="isShowRecommendDialog"
      :isShowCancel="false"
      :successBtn="'填写'"
      :canClickClose="false"
      :confirmLoading="isRecommendConfirm"
      @hideDialog="handleRecommendConfirm"
      @handleCloseBefor="beforeRecommendCloseFunc"
    >
      <div class="dialog-wrapper colect-info" >
        <el-form ref="recommendForm" :model="recommendData" :rules="recommendrules" label-width="80px">
          <el-form-item prop="organName" label="协会名称">
            <el-select class="w340px" v-model="recommendData.organName" filterable clearable="" placeholder="请选择区体育行政部门">
              <el-option
                v-for="item in orgList"
                :key="item.uuid"
                :label="item.organName"
                :value="item.organName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="password" label="校验码">
            <el-input class="w340px" v-model.trim="recommendData.password" placeholder="请输入校验码"></el-input>
          </el-form-item>
        </el-form>
        <!-- 协会  校验码 -->
      </div>
    </dialog-wrapper>

    <!-- 球员推荐 -->
    <dialog-wrapper
      :title="'请选择推荐协会'"
      :showFlag="isShowPlayerRecommended"
      :isShowCancel="false"
      :successBtn="'填写'"
      :canClickClose="false"
      :confirmLoading="isPlayerRecommendConfirm"
      @hideDialog="handlePlayerRecommendConfirm"
      @handleCloseBefor="beforePlayerRecommendCloseFunc"
    >
      <div class="dialog-wrapper colect-info" >
        <el-form ref="recommendPlayerForm" :model="recommendData" :rules="recommendrules" label-width="80px">
          <el-form-item prop="organName" label="协会名称">
            <el-select class="w340px" v-model="recommendData.organName" filterable clearable="" placeholder="请选择区体育行政部门">
              <el-option
                v-for="item in orgList"
                :key="item.uuid"
                :label="item.organName"
                :value="item.organName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="password" label="校验码">
            <el-input class="w340px" v-model.trim="recommendData.password" placeholder="请输入校验码"></el-input>
          </el-form-item>
        </el-form>
        <!-- 协会  校验码 -->
      </div>
    </dialog-wrapper>

    <!-- 青少年赛事 -->
    <dialog-wrapper
      :title="'请选择推荐协会'"
      :showFlag="isShowMatchRecommended"
      :isShowCancel="false"
      :successBtn="'填写'"
      :canClickClose="false"
      :confirmLoading="isMatchRecommendConfirm"
      @hideDialog="handleMatchRecommendConfirm"
      @handleCloseBefor="beforeMatchRecommendCloseFunc"
    >
      <div  class="dialog-wrapper colect-info" >
        <el-form ref="recommendMatchForm" :model="recommendData" :rules="recommendrules" label-width="80px">
          <el-form-item prop="organName" label="协会名称">
            <el-select class="w340px" v-model="recommendData.organName" filterable clearable="" placeholder="请选择区体育行政部门">
              <el-option
                v-for="item in orgList"
                :key="item.uuid"
                :label="item.organName"
                :value="item.organName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="password" label="校验码">
            <el-input class="w340px" v-model.trim="recommendData.password" placeholder="请输入校验码"></el-input>
          </el-form-item>
        </el-form>
        <!-- 协会  校验码 -->
      </div>
    </dialog-wrapper>

    <!-- 青训总监推荐 -->
    <dialog-wrapper
      :title="'请选择青训总监所在单位'"
      :showFlag="isShowMajorDomoRecommended"
      :isShowCancel="false"
      :successBtn="'填写'"
      :canClickClose="false"
      :confirmLoading="isMajorDomoRecommendConfirm"
      @hideDialog="handleMajorDomoRecommendConfirm"
      @handleCloseBefor="beforeMajorDomoRecommendCloseFunc"
    >
      <div class="dialog-wrapper colect-info" >
        <el-form ref="recommendMajorDomoForm" :model="recommendData" :rules="recommendrules" label-width="80px">
          <el-form-item prop="organName" label="单位名称">
            <el-select class="w340px" v-model="recommendData.organName" filterable clearable="" placeholder="请选择单位名称">
              <el-option
                v-for="item in orgList"
                :key="item.uuid"
                :label="item.organName"
                :value="item.organName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="password" label="校验码">
            <el-input class="w340px" v-model.trim="recommendData.password" placeholder="请输入校验码"></el-input>
          </el-form-item>
        </el-form>
        <!-- 协会  校验码 -->
      </div>
    </dialog-wrapper>

    <!-- 急救培训班 -->
    <dialog-wrapper
      :title="'请选择协会填写'"
      :showFlag="isShowEmergencyRecommended"
      :isShowCancel="false"
      :successBtn="'填写'"
      :canClickClose="false"
      :confirmLoading="isEmergencyRecommendConfirm"
      @hideDialog="handleEmergencyRecommendConfirm"
      @handleCloseBefor="beforeEmergencyRecommendCloseFunc"
    >
      <div class="dialog-wrapper colect-info" >
        <el-form ref="recommendEmergencyForm" :model="recommendData" :rules="recommendrules" label-width="80px">
          <el-form-item prop="organName" label="协会名称">
            <el-select class="w340px" v-model="recommendData.organName" filterable clearable="" placeholder="请选择区体育行政部门">
              <el-option
                v-for="item in orgList"
                :key="item.uuid"
                :label="item.organName"
                :value="item.organName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="password" label="校验码">
            <el-input class="w340px" v-model.trim="recommendData.password" placeholder="请输入校验码"></el-input>
          </el-form-item>
        </el-form>
        <!-- 协会  校验码 -->
      </div>
    </dialog-wrapper>

    <!-- 线上青训大纲分享会 -->
    <dialog-wrapper
      :title="'请选择所在单位'"
      :showFlag="isShowLineOutlineRecommended"
      :isShowCancel="false"
      :successBtn="'填写'"
      :canClickClose="false"
      :confirmLoading="isLineOutlineRecommendConfirm"
      @hideDialog="handleLineOutlineRecommendConfirm"
      @handleCloseBefor="beforeLineOutlineRecommendCloseFunc"
    >
      <div class="dialog-wrapper colect-info" >
        <el-form ref="recommendLineOutlineForm" :model="recommendData" :rules="recommendrules" label-width="80px">
          <el-form-item prop="organName" label="单位名称">
            <el-select class="w340px" v-model="recommendData.organName" filterable clearable="" placeholder="请选择单位名称">
              <el-option
                v-for="item in orgList"
                :key="item.uuid"
                :label="item.organName"
                :value="item.organName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="password" label="校验码">
            <el-input class="w340px" v-model.trim="recommendData.password" placeholder="请输入校验码"></el-input>
          </el-form-item>
        </el-form>
        <!-- 协会  校验码 -->
      </div>
    </dialog-wrapper>

    <!-- 运动能力测试 -->
    <dialog-wrapper
      :title="'运动能力测试文件'"
      :showFlag="isShowAthleticAbilityRecommended"
      :isShowCancel="false"
      :successBtn="'关闭'"
      :canClickClose="false"
      :confirmLoading="isAthleticAbilityRecommendConfirm"
      @hideDialog="handleAthleticAbilityRecommendConfirm"
      @handleCloseBefor="beforeAthleticAbilityRecommendCloseFunc"
    >
      <div class="dialog-wrapper colect-info athletic-ability" >
        <p><span>运动能力测试文件：</span> <a href="http://rescdn.yioks.cn/zuxie/%E4%B8%AD%E5%9B%BD%E8%B6%B3%E5%8D%8F%E8%BF%90%E5%8A%A8%E8%83%BD%E5%8A%9B%E6%B5%8B%E8%AF%95%E5%9F%B9%E8%AE%AD%E8%A7%86%E9%A2%91.mp4" target="_blank">测试培训视频（mp4）</a> <a href="http://rescdn.yioks.cn/zuxie/%E4%B8%AD%E5%9B%BD%E8%B6%B3%E5%8D%8F%E8%BF%90%E5%8A%A8%E8%83%BD%E5%8A%9B%E6%B5%8B%E8%AF%95%E6%96%B9%E6%B3%95%E6%8C%87%E5%AF%BC.pdf" target="_blank">测试方法指导（pdf）</a></p>
        <p><span>YOYO测试音频文件：</span>
          <a href="/uploads/sportsAabilityFile/YO-YO Test IER1(1).mp3" target="_blank">IR1(音频文件)</a>
          <a target="_blank" href="/uploads/sportsAabilityFile/yyir2-male-beeps(1).mp3">IR2(音频文件)</a>
        </p>
      </div>
    </dialog-wrapper>

    <!-- 青训总监研讨会 -->
    <template
      v-if="isShowSeminarDialog"
    >
      <check-code
        :isShowDialog.sync="isShowSeminarDialog"
        :btnLoading.sync="isSeminarLoading"
        :requestName="checkCodeForSeminarInfo"
        :orgList="orgList"
        @checkCallBack="handleSeminarCallBack"
      ></check-code>
    </template>


<!--    教练员操作视频-->
    <el-dialog :visible.sync="isQuestion"
               title="教练员操作视频"
               :close-on-click-modal="false"
               width="600px">
      <div class="qusetion_manager_guide">
        <video controls autoplay poster='@/assets/images/login/video_bg.jpg'>
          <source src="http://rescdn.yioks.cn/shanghaizuxie/coachv2.mp4" type="video/mp4">
          <source src="http://rescdn.yioks.cn/shanghaizuxie/coachv2.webm" type="video/webm">
          浏览器不支持HTML5的视频播放功能
        </video>
      </div>
    </el-dialog>
    <yioks-tips :showTip="tipsLoginFlag"
      :tipMsg="tipsLoginMsg"
      @callback="hideLoginTipsDialog"></yioks-tips>
  </div>
</template>

<script>
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/lock'
// eslint-disable-next-line camelcase
import { hex_hmac_sha256 } from '@/utils/sha'
import { filterCode } from '@/utils/yioks_filter'
import storage from '@/utils/storage'
import auth from '@/api/auth'
import common from '@/api/common'
// import { JSEncrypt } from 'jsencrypt'
import JSEncrypt from '@/assets/js/jsencrypt.min.js'
import { requiredItem } from "@/assets/js/formRules"
import { getOrgList, checkOrg, checkOrgForCoach, organPlayerRecommendCheck, organMatchCheck, organMajorDomoRecommendCheck,organEmergencyRecommendCheck, organLineOutlineRecommendCheck, checkCodeForSeminarInfo } from "@/api/tempApi";
import { orgList } from '@/assets/js/organList';
import api from '@/api'
import mixinAppConfig from '@/mixin/mixinAppConfig';
import regions from "@/utils/regions";
import Tips from "@/components/YioksTipHtml";


export default {
  name: 'Login',
  mixins: [mixinAppConfig],
  beforeRouteEnter (to, from, next) {
    // 是否存在 token ，存在检测 token 是否失效，存在且token未失效直接跳转 home页
    if (storage.get('token')) {
      auth.checkLogin().then(res => {
        if (res.code) {
          next()
        } else {
          storage.set('token', res.yioksToken)
          storage.set('loginToken', res.yioksToken)
          storage.set('showCoachLimit', 1);
          next('/home/index')
        }
      }).catch(err => {
        next()
      })
    } else {
      next()
    }
  },
  components: {
    'PageFoot': () => import('@/components/layout/PageFoot'),
    'forget-pwd': () => import('./ForgetPwd'),
    'dialog-wrapper': () => import('@/components/tips/DialogWrap'),
    'check-code': () => import("@/components/checkOrgCode/index"),
    "yioks-tips": Tips,
  },
  data () {
    const isWin = /windows|win32|win64/i.test(navigator.userAgent)
    const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
    return {
      regions,
      orgList:[],
      colectFormData: {
        organName:'',
        password:'',
      },
      colectrules: {
        organName: requiredItem('协会名称', true),
        password: requiredItem('校验码'),
      },
      recommendData: {
        organName:'',
        password:'',
      },
      recommendrules: {
        organName: requiredItem('单位名称', true),
        password: requiredItem('校验码'),
      },
      isQuestion: false,  // 显示教练员操作视频
      isShowColect: false,  // 信息收集弹窗开关
      isDialogConfirm: false, // 信息收集确认按钮loading
      isShowRecommendDialog: false,  // 教练员推荐
      isShowPlayerRecommended: false,  // 优秀球员推荐
      isShowMatchRecommended: false,  // 优秀球员推荐
      isRecommendConfirm: false,  // 教练员推荐确认
      isPlayerRecommendConfirm: false,  // 球员推荐确认
      isMatchRecommendConfirm: false,  // 球员推荐确认
      isShowMajorDomoRecommended: false,  // 青训总监推荐
      isMajorDomoRecommendConfirm: false,  // 青训总监推荐确认
      isEmergencyRecommendConfirm: false,  // 急救培训班确认
      isShowEmergencyRecommended: false,  // 急救培训班
      isLineOutlineRecommendConfirm: false,  // 线上青训大纲分享会推荐确认
      isShowLineOutlineRecommended: false,  // 线上青训大纲分享会
      isShowAthleticAbilityRecommended: false,  // 运动能力测试文件
      isAthleticAbilityRecommendConfirm: false,  // 运动能力测试文件推荐确认
      isWin,
      isMac,
      userName: '',
      passWord: '',
      nameWraing: false,
      pwdWraing: false,
      repeatSubmit: false,
      rememberUser: false,
      forget: this.$route.query.forget === 'y',
      isVerifyPhone: false,
      code_flag: false, // 用于标记后台返回错误提示，进行重校验
      code_msg: '', // 存储后台错误提示
      form: {
        mobile_phone: '',
        pwd: '',
        affirm_pwd: '',
        code: ''
      },
      rules: {
        code: [
          {
            required: true,
            validator: (rule, val, callback) => {
              if (this.$rule.code(val)) {
                if (!this.code_flag) {
                  callback()
                } else {
                  this.code_flag = false
                  callback(new Error(this.code_msg))
                }
              } else {
                callback(new Error('请输入有效的验证码'))
              }
            },
            trigger: 'blur'
          }
        ],
        pwd: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.$rule.password(value)) {
                callback(new Error('8—16位字母（区分大小写）和数字组合'))
              } else {
                if (this.form.affirm_pwd !== '') {
                  this.$refs.form.validateField('affirm_pwd')
                }
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        affirm_pwd: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.$rule.password(value)) {
                callback(new Error('8—16位字母（区分大小写）和数字组合'))
              } else if (value !== this.form.pwd) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      codeBtnFlag: true,
      errPhoneFlag: false,
      errPhoneMsg: '',
      sec: 60,
      user: {},
      isShowSeminarDialog: false, // 青训总监研讨会
      isSeminarLoading: false,
      checkCodeForSeminarInfo,  // 青训总监研讨会校验
      hmac_pwd:'',
      tipsLoginMsg: "此帐号已经在另一个地方登录，继续登录被迫使对方下线，是否继续登录？",
      tipsLoginFlag: false,
    }
  },
  computed: {
    isShowDownloadEntrance () {
      const { forget } = this.$route.query;
      return forget !== 'y'
    },
  },
  created () {
    this.rmbUser();
    this.$store.dispatch('appConfig/setConfigSync')
  },

  mounted() {

    // this.loadOrgList();  //
    // document.title = this.$store.getters.sysPlatformName; // 修改名字
    this.setDetaultUserName();
  },
  methods: {
    /* 加载协会列表 */
    loadOrgList() {
      getOrgList().then( res => {
        if(res.code) {
          this.$message.error(res.msg);
          return
        }
        this.orgList = res;
      }).catch( err => {
        console.error(err)
      })
    },

    forgetPwd () {
      this.forget = true
      this.$router.replace({
        path: '/login',
        query: {
          forget: 'y'
        }
      })
    },
    gotoOpinion () {
      this.$router.push({
        path: 'talent'
      })
    },
    // /*教练员报名入口*/
    toRegion () {
      this.$router.push({
        path: 'recruitmentInfo'
      })
    },
    toCourseApply () {
      this.$router.push({
        path: 'courseApply'
      })
    },
    rmbUser () {
      let loginData = storage.get('loginData')
      if (loginData) {
        this.userName = loginData.userName
        this.passWord = loginData.passWord
        this.rememberUser = true
      }
    },
    check () {
      // 防止重复请求
      if (this.repeatSubmit) return
      this.repeatSubmit = true
      if (this.userName === '') {
        this.nameWraing = true
        this.repeatSubmit = false
      }
      if (this.passWord === '') {
        this.pwdWraing = true
        this.repeatSubmit = false
      }
      if (this.userName && this.passWord) this.getSalt()
    },
    // 注册
    toRegionPage() {
      this.$router.push({
        path: '/region_new',
        // query: {

        // }
      })
    },
    getSalt () {
      auth.getSalt(this.userName).then(res => {
        const str = hex_hmac_sha256(res.salt, this.passWord).toUpperCase()
        const pwd = hex_hmac_sha256(res.token, str + this.userName)

        if (!res.onlineIp) {
          this.login(pwd);
          return;
        }else{
          this.hmac_pwd = pwd;
          this.tipsLoginMsg = "此帐号已经在另一个地方登录<br>登录IP："
            +res.onlineIp
            +"<br>继续登录被迫使对方下线<br>是否继续登录？"
          this.tipsLoginFlag = true;
          return;
        }
      }).catch(err => {
        this.repeatSubmit = false
        console.error(err)
      })
    },
    login (pwd) {
      auth.login('yioks-password', { username: this.userName, password: pwd }).then(res => {
        if (res.code) {
          const string = /.*\d+$/
          if (string.test(res.code)) {
            this.$message.error(res.msg)
          } else {
            this.$message.error(filterCode(res.code))
          }
          this.repeatSubmit = false
          // storage.remove('token')
        } else {
          this.rememberUser ? storage.set('loginData', { userName: this.userName, passWord: this.passWord }) : storage.remove('loginData')
          if (res.roleCodes.length > 1) {
            //  auth.getRoleCodes().then(res => {})
            const appConfig = this.$store.getters.sysHostType;

            if(res.roleCodes.includes(appConfig)) {
              // 当前进入club平台
              this.checkRole(appConfig, res.yioksToken)
            } else {
              console.error('roleCodes list is error: ', res.roleCodes)
            }
          } else {
            this.checkRole(res.roleCodes[0], res.yioksToken)
          }
        }
      }).catch(err => {
        this.repeatSubmit = false
        console.error(err)
      })
    },
    checkRole (code, token) {
      this.user = { code, token }
      auth.checkoutRole(code).then(res => {
        if (res.code) {
          const string = /.*\d+$/
          if (string.test(res.code)) {
            this.$message.error(res.msg)
          } else {
            this.$message.error(filterCode(res.code))
          }
          this.repeatSubmit = false
        } else {
          const { createPlan } = res;
          if(createPlan !== undefined) {
            storage.set('createPlan', createPlan);
          }
          if (!res.phoneValid) {
            this.form.mobile_phone = res.zuxieGuoziUser.phone
            this.isVerifyPhone = true
          } else {
            this.userLogin()
          }
        }
      }).catch(err => {
        this.repeatSubmit = false
        console.error(err)
      })
    },
    countdown () {
      this.codeBtnFlag = false
      const timer = setInterval(() => {
        this.sec = this.sec - 1
        if (this.sec === 0) {
          this.sec = 60
          this.codeBtnFlag = true
          clearInterval(timer)
        }
      }, 1000)
    },
    sendCode () {
      common.resetSendVerifyCode().then(res => {
        if (res.code) {
          this.errPhoneMsg = res.msg
          this.errPhoneFlag = true
        } else {
          this.$message.success('验证码发送成功~')
          this.errPhoneFlag = false
          /* 倒计时 */
          this.countdown()
        }
      }).catch(err => {
        console.error(err)
      })
    },
    onSubmitPwd () {
      this.$refs.form.validate(async vali => {
        if (vali) {
          let publicKey = await auth.getPublicKey(this.userName)
          let encryptor = new JSEncrypt()
          encryptor.setPublicKey(publicKey)
          let rsaPassword = encryptor.encrypt(this.form.pwd)
          common.loginFindPassword({ code: this.form.code, newPassword: rsaPassword }).then(res => {
            if (res.code) {
              const string = /.*\d+$/
              if (string.test(res.code)) {
                this.$message.error(res.msg)
              } else {
                this.$message.error(filterCode(res.code))
              }
            } else {
              this.userLogin()
            }
          })
        }
      })
    },
    userLogin () {
      storage.set('token', this.user.token)
      storage.set('loginToken', this.user.token)
      storage.set('showCoachLimit', 1);
      this.$store.commit('setHeartBeat')
      common.getUserInfo().then(res => {
        if (!res.code) {
          let { uuid, idName, headImgUrl } = res
          this.$store.commit('updataInfo', { uuid, idName, headImgUrl, userRole: this.user.code })
          this.$router.push('/home/index')
        }
      }).catch(err => {
        this.repeatSubmit = false
        storage.remove('token')
        storage.remove('loginToken')
        this.$store.commit('clearHeart')
        console.error(err)
      })
    },
    hideLoginTipsDialog(bool){
      this.tipsLoginFlag = false;
      if (bool) {
        // 点击确定继续登录
        this.login(this.hmac_pwd);
        return;
      } else {
        this.hmac_pwd = '';
        this.repeatSubmit = false;
        return;
      }
    },

    /* 打开青少年球队信息收集表选择弹窗 */
    openColectInfoDialog() {
      this.isShowColect = true;
    },

    /* 打开教练推荐弹窗 */
    openRecommended() {
      this.isShowRecommendDialog = true;
    },
    openPlayerRecommended () {
      this.isShowPlayerRecommended = true;
    },
    openMajorDomoRecommended () {
      this.isShowMajorDomoRecommended = true
    },
    openEmergencyRecommended () {
      this.isShowEmergencyRecommended = true
    },
    openMatchRecommended () {
      this.isShowMatchRecommended = true
    },
    openLineOutlineRecommended () {
      this.isShowLineOutlineRecommended = true
    },
    openAthleticAbilityRecommended () {
      this.isShowAthleticAbilityRecommended = true
    },

    /* 弹窗回调 */
    handleColectDialogConfirm(flag, ok) {
      if(ok) {
        const formData = this.colectFormData
        this.$refs.colectForm.validate( (valid) => {
          if(valid) {
            const submitData = {
              organName: formData.organName,
              code: formData.password,
            }
            checkOrg(submitData).then(res => {
              if (res.code){
                this.$message.error(res.msg);
                return
              }
              this.$router.push({
                name: 'TeamInfoColect',
                query: {
                  orgName: res.organName,
                  orgUuid:  res.uuid,
                  password: formData.password
                }
              })
            })
          } else {
            console.error('form colectForm valid fail');
            this.isShowColect = true;
            return false
          }
        })
      } else {
        this.isShowColect = flag;
      }
    },


    /* 弹窗关闭 */
    beforeCloseFunc() {
      this.$refs.colectForm.resetFields()
    },

    /* 教练推荐弹窗回调*/
    handleRecommendConfirm(flag, ok) {
      if(ok) {
        const formData = this.recommendData
        this.$refs.recommendForm.validate( (valid) => {
          if(valid) {
            const submitData = {
              organName: formData.organName,
              code: formData.password,
            }
            checkOrgForCoach(submitData).then(res => {
              if (res.code){
                this.$message.error(res.msg);
                return
              }
              this.$router.push({
                name: 'CoachRecommend',
                query: {
                  orgName: res.organName,
                  orgUuid:  res.uuid,
                  password: formData.password
                }
              })
            })
          } else {
            console.error('form colectForm valid fail');
            this.isShowRecommendDialog = true;
            return false
          }
        })
      } else {
        this.isShowRecommendDialog = flag;
      }
    },

    /* 关闭回调 */
    beforeRecommendCloseFunc() {
      this.$refs.recommendForm.resetFields()
    },

    /* 关闭回调 */
    beforePlayerRecommendCloseFunc() {
      this.$refs.recommendPlayerForm.resetFields()
    },

    /* 教练推荐弹窗回调*/
    handlePlayerRecommendConfirm(flag, ok) {
      if(ok) {
        const formData = this.recommendData
        this.$refs.recommendPlayerForm.validate( (valid) => {
          if(valid) {
            const submitData = {
              organName: formData.organName,
              code: formData.password.toUpperCase(),
            }
            organPlayerRecommendCheck(submitData).then(res => {
              if (res.code){
                this.$message.error(res.msg);
                return
              }
              this.$router.push({
                name: 'PlayerRecommend',
                query: {
                  orgName: res.organName,
                  orgUuid:  res.uuid,
                  password: formData.password.toUpperCase()
                }
              })
            })
          } else {
            console.error('form colectForm valid fail');
            this.isShowPlayerRecommended = true;
            return false
          }
        })
      } else {
        this.isShowPlayerRecommended = flag;
      }
    },

    /* 关闭回调 */
    beforeMatchRecommendCloseFunc () {
      this.$refs.recommendMatchForm.resetFields()
    },

    /* 赛事*/
    handleMatchRecommendConfirm (flag, ok) {
      if(ok) {
        const formData = this.recommendData
        this.$refs.recommendMatchForm.validate( (valid) => {
          if(valid) {
            const submitData = {
              organName: formData.organName,
              code: formData.password,
            }
            organMatchCheck(submitData).then(res => {
              if (res.code){
                this.$message.error(res.msg);
                return
              }
              this.$router.push({
                name: 'YouthMatch',
                query: {
                  orgName: res.organName,
                  orgUuid:  res.uuid,
                  password: formData.password
                }
              })
            })
          } else {
            console.error('form colectForm valid fail');
            this.isShowMatchRecommended = true;
            return false
          }
        })
      } else {
        this.isShowMatchRecommended = flag;
      }
    },

    /* 青训总监收集弹窗回调*/
    handleMajorDomoRecommendConfirm(flag, ok) {
      if (ok) {
        const formData = this.recommendData
        this.$refs.recommendMajorDomoForm.validate((valid) => {
          if (valid) {
            const submitData = {
              organName: formData.organName,
              code: formData.password,
            }
            organMajorDomoRecommendCheck(submitData).then(res => {
              if (res.code) {
                this.$message.error(res.msg);
                return
              }
              this.$router.push({
                name: 'majorDomoRecommend',
                query: {
                  orgName: res.organName,
                  orgUuid: res.uuid,
                  password: formData.password
                }
              })
            })
          } else {
            console.error('form colectForm valid fail');
            this.isShowMajorDomoRecommended = true;
            return false
          }
        })
      } else {
        this.isShowMajorDomoRecommended = flag;
      }
    },

    /* 关闭回调 */
    beforeMajorDomoRecommendCloseFunc () {
      this.$refs.recommendMajorDomoForm.resetFields()
    },

    /* 急救培训班弹窗回调*/
    handleEmergencyRecommendConfirm(flag, ok) {
      if (ok) {
        const formData = this.recommendData
        this.$refs.recommendEmergencyForm.validate((valid) => {
          if (valid) {
            const submitData = {
              organName: formData.organName,
              code: formData.password,
            }
            organEmergencyRecommendCheck(submitData).then(res => {
              if (res.code) {
                this.$message.error(res.msg)
                return
              }
              this.$router.push({
                name: 'emergencyRecommend',
                query: {
                  orgName: res.organName,
                  orgUuid: res.uuid,
                  password: formData.password
                }
              })
            })
          } else {
            console.error('form colectForm valid fail')
            this.isShowEmergencyRecommended = true
            return false
          }
        })
      } else {
        this.isShowEmergencyRecommended = flag;
      }
    },

    /* 关闭回调 */
    beforeEmergencyRecommendCloseFunc () {
      this.$refs.recommendEmergencyForm.resetFields()
    },

    /* 线上青训大纲分享弹窗回调*/
    handleLineOutlineRecommendConfirm(flag, ok) {
      if (ok) {
        const formData = this.recommendData
        this.$refs.recommendLineOutlineForm.validate((valid) => {
          if (valid) {
            const submitData = {
              organName: formData.organName,
              code: formData.password,
            }
            organLineOutlineRecommendCheck(submitData).then(res => {
              if (res.code) {
                this.$message.error(res.msg);
                return
              }
              this.$router.push({
                name: 'lineOutlineRecommend',
                query: {
                  orgName: res.organName,
                  orgUuid: res.uuid,
                  password: formData.password
                }
              })
            })
          } else {
            console.error('form colectForm valid fail');
            this.isShowLineOutlineRecommended = true;
            return false
          }
        })
      } else {
        this.isShowLineOutlineRecommended = flag;
      }
    },

    /* 关闭回调 */
    beforeLineOutlineRecommendCloseFunc () {
      this.$refs.recommendLineOutlineForm.resetFields()
    },

    // 打开青训总监校验码
    handleInputSeminar() {
      this.isShowSeminarDialog = true;
    },

    // 青训总监校验码验证回调
    handleSeminarCallBack(dialogStatus, confirmStatus, formData) {
      if(confirmStatus) {
        console.log('确认')
        this.$router.push({
          path: '/seminarInfo',
          query: {
            ...formData
          }
        })
      } else {
        console.log('取消')
      }
      this.isShowSeminarDialog = dialogStatus;
    },

    /* 运动能力测试弹窗回调*/
    handleAthleticAbilityRecommendConfirm (flag, ok) {
      this.isShowAthleticAbilityRecommended = false;
    },

    /* 关闭回调 */
    beforeAthleticAbilityRecommendCloseFunc () {
      this.isShowAthleticAbilityRecommended = false;
    },

    setDetaultUserName() {
      const { userName } = this.$route.query;
      if(userName) this.userName = userName;
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .loginBox
    height 100%
    display flex
    justify-content center
    flex-direction column
    align-items center
    .athletic-ability
      font-size 15px
      p
       line-height 40px
      a
       color $green_color
       margin-left 8px
    .safe_area
      height calc(100% - 60px)
      width: 1024px;
      .logo
        padding 100px 0
        display flex
        justify-content center
        img
          &:first-child
            width 120px
            /*hieght 120px*/
            margin-right 12px
          &:last-child
            width 1000px
            // width 594px
            /*hieght 113px*/
      .login_wrap
        width 450px
        padding 15px 70px 25px
        background $black_color
        /*float right*/
        /*align-self flex-end*/
        .input_box
          height 40px
          display flex
          background #FFF
          margin-bottom 40px
          position relative
          input
            width 100%
            padding 0 15px 0 55px
            border 1px solid transparent
            &:focus
              border 1px solid $green_color
              box-shadow 0px 0px 5px 1px $green_color
            &:focus + .icon_box
              color $green_color
            &.username
              padding-right 40px
          .error
            box-shadow 0 0 5px 1px rgba(222, 16, 36, 0.4)
            border 1px solid rgb(222, 16, 36)
            outline none
          .icon_box
            position absolute
            top 0
            left 0
            width 40px
            height 100%
            color: #ceced2
            border-right 1px solid #ceced2
            text-align center
            display flex
            justify-content center
            align-items center
        .name_tip
          width 20px
          height 20px
          position absolute
          right 10px
          top 50%
          transform translate(0, -50%)
        .btn
          height 40px
          width 100%
          background $green_color
          line-height 40px
          font-size 16px
          color #FFF
          text-align center
          cursor pointer
          user-select none
          &.primary
            background-color $blue_color
        .other_info
          margin-top 32px
          display flex
          justify-content space-between
          font-size 16px
          color #FFF
          .remember_pwd
            display flex
            position relative
            align-items center
            user-select none
            input
              position absolute
              width 20px
              height 20px
              cursor pointer
              opacity 0
              z-index 1
              &:checked + label::before
                opacity 1
            label
              display block
              width 18px
              height 18px
              background #FFF
              border 1px solid $green_color
              border-radius 5px
              margin-right 15px
              &::before
                content ''
                display block
                width 5px
                height 10px
                border-right 2px solid $green_color
                border-bottom 2px solid $green_color
                margin 1px 0 0 6px
                transform rotate(45deg)
                opacity 0
          .forget_pwd
            color #CECED2
            cursor pointer
        .tip
          font-size 14px
          color #CECED2
          text-align right
          margin-top 20px
          display block
          a
            color #CECED2
      .buttonSuggest, .buttonSuggestTips {
        /*align-self flex-end*/
        width 430px
        /*margin 87px 22px 0 210px*/
        /*float right*/
        .ab_enter {
          padding 15px 10px
          line-height 1.2
          font-size: 14px;
          color: #ffffff;
          background-color: #3a8ee6;
          cursor: pointer;
        }
        .t-tips {
          padding 15px 10px
          line-height 1
          font-size: 14px;
          color: #ffffff;
          background-color: #3a8ee6;
          cursor: pointer;
        }
      }
      .recruitment {
        width: 215px
        margin 20px 0 0 20px
        .btn {
          padding 15px 10px
          line-height 1.2
          font-size 14px
          color #FFFFFF
          background-color #4cd964
          cursor pointer
        }
      }
      .Recommended {
        width: 230px
        margin 20px 0 0 20px
        .btn {
          padding 15px 10px
          line-height 1.2
          font-size 14px
          color #FFFFFF
          background-color #4cd964
          cursor pointer
        }
      }
      .login-item {
        width: 220px
        margin 20px 0 0 20px
        text-align center
        .btn {
          padding 15px 10px
          line-height 1.2
          font-size 14px
          color #FFFFFF
          background-color #3a8ee6
          cursor pointer
        }
      }
#VerifyPhone {
  font-size: 16px
  .tips {
    position: absolute;
    right: 22px;
    bottom: 66px;
    color: #ff0000;
    font-size: 14px;
  }
  .get_none_code{
    position absolute
    bottom -30px
    cursor pointer
    right 0
    color #606266
  }
  .btns {
    display: flex;
    margin-top: 40px;

    .btn {
      padding: 5px 20px;
      margin: 0 20px;
      font-size: 16px;
      color: #FFF;
      border-radius: 2px;
      cursor: pointer;
    }

    .yes {
      margin-left: 110px;
      background-color: #4cd964;
      box-shadow: 0px 2px 10px #4cd964;
    }

    .no {
      background-color: #ff0000;
      box-shadow: 0px 2px 10px #ff0000;
    }
  }
}
  .position-all-wrapper{
    display:flex
    align-items flex-end
    // justify-items flex-end
    justify-content center
    position: relative;
    .cfa_center {
      position absolute
      right 0
      top 0
      transform translateY(-100%)
      border-radius 5px 5px 0 0
      padding 10px 20px
      line-height 1.2
      font-size: 15px;
      color: #fff;
      background-color: #4cd964;
      cursor: pointer;
    }
    .empty-box {
      height 10px
      width calc(100% - 40%)
    }
    .login-flex-wrapper {
      /*width */
      display flex
      flex-direction column
      align-items left
      position relative
      /*justify-content flex-end*/
      .buttonSuggest {
        display flex
        justify-content center
        margin-top 20px
        width 290px
      }
      .buttonSuggestTips {
        display flex
        justify-content flex-end
        margin-top 33px
        width 610px
      }
    }
  }
  .login-title {
    font-size 14px
    color red
    width 100%
    height 60px
    display flex
    justify-content center
    align-items center
  }
  .in-box {
    display: flex
    position absolute;
    top: 410px;
    right 0;
  }
  .in-box1 {
    display: flex
    position absolute;
    top: 360px;
    right -75px;
  }

  .w340px {
    width 340px
  }
  .dialog-wrapper {
    padding 20px 15px 50px
  }
  .mt10 {
    margin-top 10px
  }

  .qusetion_manager_guide {
    text-align: center;
    padding: 0 20px;
    video {
      width: 100%;
      height: 100%;
    }
    .manager_ppt {
      padding: 15px;
    }
  }
</style>

<style lang="stylus" scoped>
  @media screen and (max-width: 1024px)
    .loginBox .safe_area .login_wrap {
      margin: 0 100px 0 0;
    }
    .loginBox .safe_area .forget_wrap {
      margin: 0 100px 0 0;
    }
</style>
<style lang="stylus">
  .VerifyPhone
    .el-dialog__header
      font-size 16px !important

  .loginBox
    .el-dialog__header
      font-size 18px
</style>
